module.exports = __webpack_public_path__ + "static/media/N.8c60170e.jpg";